import React from 'react'; 

const CopyIcon = () => (
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9617 2C9.73703 2 8.7442 2.89543 8.7442 4V12C8.7442 13.1046 9.73703 14 10.9617 14H17.6144C18.8391 14 19.8319 13.1046 19.8319 12V6.41421C19.8319 5.88378 19.5983 5.37507 19.1824 5L16.5056 2.58579C16.0897 2.21071 15.5257 2 14.9376 2H10.9617Z" fill="#439ADE"/>
        <path d="M4.30908 8C4.30908 6.89543 5.30191 6 6.52663 6V16H15.3968C15.3968 17.1046 14.404 18 13.1793 18H6.52663C5.30191 18 4.30908 17.1046 4.30908 16V8Z" fill="#439ADE"/>
    </svg>
)

export default CopyIcon